import { cx } from 'class-variance-authority';
import { type ButtonHTMLAttributes, forwardRef } from 'react';

type FilterButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  children: React.ReactNode;
  hasFilters?: boolean;
  onClick?: () => void;
  className?: string;
};

const FilterButton = forwardRef<HTMLButtonElement, FilterButtonProps>(
  ({ children, onClick, hasFilters, className, ...props }, ref) => {
    return (
      <button
        {...props}
        ref={ref}
        onClick={onClick}
        type="button"
        className={cx(
          'text-label-3 h-8 inline-flex items-center justify-center bg-primary px-3 border rounded-(--button-border-radius)',
          'transition-all duration-200 ease-in-out w-fit whitespace-nowrap',
          'cursor-pointer hover:bg-hover-control',
          {
            'text-primary border-tertiary': !hasFilters,
            'text-accent border-secondary': hasFilters,
          },
          className,
        )}
      >
        {children}
      </button>
    );
  },
);

export default FilterButton;
